import { camelCase, isObject, transform } from 'lodash'

export const camelize = <T>(obj: any): T =>
  transform<unknown, T>(obj, (result, value, key, target) => {
    const camelKey = Array.isArray(target) ? key : camelCase(key.toString())
    ;(result as any)[camelKey] = isObject(value)
      ? camelize(value as Record<string, unknown>)
      : value
  })
